import React, { useMemo, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box } from '@mui/material';
import AdminPortalAppService from '../../application/platform/admin-portal/admin-portal-app-service';
import './rich-text-editor.css';

interface RichTextEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    readOnly?: boolean;
    error?: boolean;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value,
    onChange,
    placeholder = 'Digite o conteúdo...',
    readOnly = false,
    error = false
}) => {
    const quillRef = useRef<ReactQuill>(null);

    const handleImageUpload = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files?.[0];
            if (!file) return;

            const editor = quillRef.current?.getEditor();
            const range = editor?.getSelection(true);

            try {
                const { documentoUrl } = await AdminPortalAppService.uploadDocumento(file);
                editor?.insertEmbed(range?.index ?? 0, 'image', documentoUrl, 'user');
                editor?.setSelection((range?.index ?? 0) + 1, 0);
            } catch (error) {
                console.error('Erro ao enviar imagem:', error);
            }
        };
    };

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                ['bold', 'italic', 'underline'],        // Negrito, Itálico, Sublinhado
                [{ 'size': ['small', false, 'large', 'huge'] }], // Tamanhos de fonte
                ['link', 'image'],                       // Links e imagem
                ['clean']                                // Remover formatação
            ],
            handlers: {
                image: handleImageUpload
            }
        }
    }), []);

    const formats = [
        'bold', 'italic', 'underline',
        'size',
        'link', 'image'
    ];

    return (
        <Box className={error ? 'rich-editor-container error' : 'rich-editor-container'}>
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                readOnly={readOnly}
            />
        </Box>
    );
};
